import * as React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

// Components
import { AbsolutePositioned } from '../../../../components/Layout/AbsolutePositioned';
import { Screen, SplitScreen } from '../../../../components/Layout/Screen';
import Counter from '../../../../components/Counter';

// Assets
import { brandColors, device } from '../../../../styles/variables';
import Title, { Subtext } from '../../../../components/Title';
import room1 from '../../../../assets/images/pages/bridging-the-gap/room1purple.png';

const StyledScreen = Screen.extend`
  position: relative;
  overflow: hidden;
`;

const StyledSplitScreen = SplitScreen.extend`
  height: 50%;
  vertical-align: top;
`;

const CounterMargins = styled.div`
  height: 100%;
  position: relative;
`;

const LowerContainer = styled.div`
  max-width: 470px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  margin: 0;
  z-index: 2;
  padding: 120px 27px 0;
  @media ${device.tablet} {
    padding: 0 6px;
    margin: 178px auto 0;
  }
  @media ${device.laptop} {
    margin: 16vh auto 0;
    padding: 0;
  }

  .counter {
    font-size: 4vh;
    line-height: 141px;
    @media ${device.tablet} {
      font-size: 90px;
    }
  }

  h1.counter {
    font-size: 2vh;
    line-height: 3vh;
    @media ${device.tablet} {
      padding-top: 16px;
      line-height: 39px;
      font-size: 24px;
    }
  }

  h2 {
    margin: auto 0;
    font-size: 24px;
    line-height: 34px;
    padding-right: 10%;
    @media ${device.tablet} {
      width: 307px;
      font-size: 24px;
      line-height: 32px;
      margin: 0 auto 200px auto;
    }
`;

const CounterContainer = styled.div`
  max-width: 470px;
  margin: 89px 0 0 0;
  width: 100%;
  padding: 0 6px;
  @media ${device.tablet} {
    margin: 178px auto 0;
  }
  @media ${device.laptop} {
    margin: 16vh auto 0;
  }

  .counter {
    font-size: 4vh;
    line-height: 141px;
    padding: 0 27px 0;
    @media ${device.tablet} {
      font-size: 90px;
    }
  }

  h1.counter {
    font-size: 2vh;
    line-height: 3vh;
    @media ${device.tablet} {
      padding-top: 16px;
      line-height: 39px;
      font-size: 24px;
    }
  }

  .title {
    text-align: center;
    width: 100%;
    position: relative;
    margin: 150px auto;
    @media ${device.laptop} {
    }
    @media ${device.tablet} {
      margin: 0 auto;
    }

    h2 {
      margin: auto 0;
      font-size: 24px;
      line-height: 34px;
      padding: 0 6px;
      @media ${device.mobileS} and (max-width: 500px) {
        bottom: unset;
        font-size: 18px;
      }
      @media ${device.tablet} {
        width: 307px;
        font-size: 24px;
        line-height: 32px;
        margin: 0 auto 200px auto;
      }
    }

    .lower-title {
      bottom: -110px;
      @media ${device.mobileS} {
        bottom: -62px;
      }
      @media ${device.tablet} {
        bottom: -62px;
      }
    }

    div {
      margin: 0 auto;
      font-size: 16px;
      line-height: 36px;
      max-width: 270px;
      width: 100%;
      position: absolute;
      bottom: -62px;
      @media ${device.tablet} {
        line-height: 39px;
        font-size: 24px;
      }
    }
  }
`;

const UpperContainer = styled.div`
  @media (max-width: 768px) {
    padding-top: 4vh;
  }
`;

const BackgroundImage = AbsolutePositioned.extend`
  background: url(${room1}) center no-repeat;
  width: 100%;
  height: 100%;
  background-size: 190px;
  @media ${device.tablet} {
    background-size: 280px;
  }
  @media ${device.desktop} {
    background-size: 320px;
  }
`;

const CounterScreen = () => (
  <StyledScreen className="counter-screen">
    <AbsolutePositioned bottom="0" right="0">
      <StyledSplitScreen background={brandColors.yellow} />
      <StyledSplitScreen background={brandColors.white} />
      <StyledSplitScreen background={brandColors.white} />
      <StyledSplitScreen background={brandColors.blue} />
    </AbsolutePositioned>
    <BackgroundImage />
    <AbsolutePositioned bottom="0" right="0">
      <CounterMargins className="counter-margins">
        <StyledSplitScreen>
          <CounterContainer>
            <UpperContainer>
              <Counter
                className="counter"
                maxCount={97}
                title="users rated the course 'Good' or 'Very Good'"
                color={brandColors.blue}
                addSymbol="%"
              />
            </UpperContainer>
          </CounterContainer>
        </StyledSplitScreen>
        <StyledSplitScreen>
          <CounterContainer>
            <Title className="title" primary={false}>
              This will give me more confidence to help people with low vision in practice.
              <Subtext>Optometrist</Subtext>
            </Title>
          </CounterContainer>
        </StyledSplitScreen>
        <StyledSplitScreen>
          <CounterContainer>
            <Title className="title" primary={false}>
              I will be much more aware of looking at these types of patients as a whole person not
              just a pair of eyes.
              <Subtext className="lower-title">Optometrist</Subtext>
            </Title>
          </CounterContainer>
        </StyledSplitScreen>
        <StyledSplitScreen>
          <LowerContainer>
            <Counter
              className="counter"
              maxCount={1516}
              title="optometrists enrolled in the course"
              color={brandColors.yellow}
            />
          </LowerContainer>
        </StyledSplitScreen>
      </CounterMargins>
    </AbsolutePositioned>
  </StyledScreen>
);

export default connect()(CounterScreen);



// WEBPACK FOOTER //
// ./src/pages/CaseStudies/BridgingTheGap/screens/Counter.jsx